import React from 'react';

import { Typography, Row, Col, InputNumber } from 'antd';

import OpenUpdateMinimumRequirementButton from 'common/components/preview-requirements/OpenUpdateMinimumRequirementButton';

import {
  RequiredPropertyItem,
  RequiredPropertyStatus,
} from './RequiredPropertyElement';

import { useGetMinimumRequirementDetail } from './hooks';
import { useGetProductFullView } from 'hooks';
import { additionalRequirementFields } from './constants';

export const AdditionalRequiredActiveProduct = ({
  requiredErrorFields = [],
  entityId,
}) => {
  const allAdditionalFields = Object.keys(additionalRequirementFields);
  const { entityRequirement } = useGetMinimumRequirementDetail();

  return (
    <>
      {allAdditionalFields.map((field) => {
        const isError = requiredErrorFields.includes(field);

        const { fieldDisplayName, fieldName, isBoolean } =
          additionalRequirementFields[field];

        return (
          <RequiredPropertyItem key={fieldName}>
            <AdditionalRequiredPropertyName
              propertyName={fieldDisplayName}
              isError={isError}
            >
              {isBoolean ? null : (
                <RequiredPropertyTotalAsset
                  value={entityRequirement?.[fieldName]}
                  isError={isError}
                />
              )}
            </AdditionalRequiredPropertyName>
            <RequiredPropertyStatus status={isError ? 'error' : 'success'} />
            {isError && (
              <AdditionalRequiredPropertyInput
                entityId={entityId}
                fieldName={fieldName}
              />
            )}
          </RequiredPropertyItem>
        );
      })}
    </>
  );
};

export const AdditionalRequiredPropertyInput = ({ entityId, fieldName }) => {
  const { productFull } = useGetProductFullView({
    productId: entityId,
  });

  return (
    <Col>
      <OpenUpdateMinimumRequirementButton
        productDetail={productFull}
        entityData={{
          ...productFull,
          id: entityId,
        }}
        item={{
          id: fieldName,
        }}
      />
    </Col>
  );
};

export const AdditionalRequiredPropertyName = ({
  propertyName,
  children,
  isError,
  ...otherProps
}) => {
  return (
    <Col span={16} {...otherProps}>
      <Row justify='space-between' align='middle'>
        <Col>
          <Typography.Text strong type={isError ? 'danger' : undefined}>
            {propertyName}
          </Typography.Text>
        </Col>
        <Col flex='120px'>{children}</Col>
      </Row>
    </Col>
  );
};

export const RequiredPropertyTotalAsset = ({ value, isError }) => {
  return (
    <InputNumber
      readOnly
      value={value}
      status={isError ? 'error' : undefined}
    />
  );
};
